var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationPlIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,400c110.5,0,200-89.5,200-200S310.5,0,200,0S0,89.5,0,200S89.5,400,200,400z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200,16c101.4,0,184,82.6,184,184s-82.6,184-184,184S16,301.4,16,200S98.6,16,200,16z M200,400 c110.5,0,200-89.5,200-200S310.5,0,200,0S0,89.5,0,200S89.5,400,200,400z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.3,56C183,56,161.4,68.5,150,88.2c-2.3-0.5-4.6-0.6-7.1-0.6c-19.4,0-35.2,15.4-35.2,34.5 c0,2.6,0.2,5,0.8,7.5C95.8,138.4,88,153,88,168.5c0,26,21.2,49.1,46.3,50.5h125.9c29-2,51.8-26.5,51.8-55.6 c0-25.5-17.8-48-41.9-54.2C265.2,78.6,238.4,56,206.3,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234,225.3c-3.1,0-5.8,2.6-5.8,5.7v34.5c0,12.5,10.3,22.6,23,22.6h18.9c2.6,8.7,10.6,15.1,20.3,15.1 c11.7,0,21.1-9.3,21.1-20.7c0-11.4-9.5-20.6-21.1-20.6c-9.6,0-17.8,6.4-20.3,15.1h-18.8c-6.3,0-11.5-5.1-11.5-11.4V231 C239.8,227.8,237.2,225.3,234,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200,225.3c-3.1,0-5.8,2.6-5.8,5.7v72.5c-8.6,2.4-15.1,10.2-15.4,19.4c-0.1,5.5,2,10.8,5.8,14.8 s9.1,6.2,14.7,6.4h0.6c11.3,0,20.8-9,21-20.2c0.2-5.5-1.9-10.8-5.8-14.8c-2.6-2.7-5.9-4.6-9.5-5.7v-72.5 C205.8,227.8,203.2,225.3,200,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.8,276.7h-18.9c-2.6-8.7-10.6-15.1-20.3-15.1c-11.7,0-21.1,9.4-21.1,20.7c0,11.4,9.5,20.6,21.1,20.6 c9.6,0,17.8-6.3,20.3-15h18.9c12.6,0,23-10.2,23-22.6v-34.6c0-3.1-2.6-5.7-5.8-5.7c-3.2,0-5.8,2.6-5.8,5.7v34.6 C160.3,271.6,155.1,276.7,148.8,276.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationPlIcn);
export default __webpack_public_path__ + "static/media/organization_pl_icn.b142c11356b32c1c7940cabed3d4a129.svg";
export { ForwardRef as ReactComponent };